import React from 'react';

import defaultUserAvatar from '@/assets/images/default-user.png';
import { getCurrencySymbol } from '@/utils/budgetCalculations';

interface WorkActivitySubmitterProfileProps {
  name: string;
  profilePicUrl?: string | null;
  hourlyRate?: number | null;
  currency?: string;
}

const WorkActivitySubmitterProfile = ({
  name,
  profilePicUrl,
  hourlyRate,
  currency = 'EUR'
}: WorkActivitySubmitterProfileProps) => {
  const showHourlyRate = hourlyRate != null;
  const rateLabel = showHourlyRate
    ? `${getCurrencySymbol(currency)}${Number.isInteger(hourlyRate) ? hourlyRate : hourlyRate.toFixed(1)}`
    : null;

  return (
    <div className="card py-5 px-6 flex flex-col items-center justify-center gap-4">
      <p className="text-sm text-secondary font-medium">Submitter Profile</p>
      {/* <div className="flex items-center gap-3"> */}
      <img
        src={profilePicUrl || defaultUserAvatar}
        alt={name}
        className="w-[72px] h-[72px] rounded-full object-cover"
        onError={(event) => {
          event.currentTarget.src = defaultUserAvatar;
        }}
      />
      <div>
        <p className="text-base font-semibold text-center">{name}</p>
        {showHourlyRate && (
          <p className="text-sm text-secondary font-medium text-center">
            <span className="text-base font-semibold text-gray">{rateLabel}</span>/hour
          </p>
        )}
      </div>
      {/* </div> */}
    </div>
  );
};

export default WorkActivitySubmitterProfile;
